import IIcon from "interfaces/icon";

function Warning({ color = "#F04438" }: IIcon) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0566 22.0005H3.94264C3.41206 22.0005 2.89085 21.8608 2.43136 21.5955C1.97188 21.3302 1.59031 20.9486 1.325 20.4891C1.05969 20.0297 0.919985 19.5084 0.919922 18.9779C0.919858 18.4473 1.05944 17.9261 1.32464 17.4665L9.38164 3.51151C9.64696 3.05195 10.0286 2.67033 10.4881 2.40501C10.9477 2.13968 11.469 2 11.9996 2C12.5303 2 13.0516 2.13968 13.5111 2.40501C13.9707 2.67033 14.3523 3.05195 14.6176 3.51151L22.6746 17.4665C22.9398 17.9261 23.0794 18.4473 23.0794 18.9779C23.0793 19.5084 22.9396 20.0297 22.6743 20.4891C22.409 20.9486 22.0274 21.3302 21.5679 21.5955C21.1084 21.8608 20.5872 22.0005 20.0566 22.0005Z"
        fill={color}
      />
      <path
        d="M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z"
        fill="white"
      />
      <path
        d="M12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14Z"
        fill="white"
      />
    </svg>
  );
}

export default Warning;
